// UI Payment Element Events
export enum UI_PAYMENT_ELEMENT_EVENT {
  READY = 'ready',
  PROCESSING = 'processing',
  SUCCESS = 'success',
  ERROR = 'error',
  PREPROCESS = 'pre_process',
  CLOSE = 'close',
}

// Payment Status
export enum PaymentStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}

// Payment Provider
export enum PaymentProvider {
  STRIPE = 'stripe',
  PAYPAL = 'paypal',
  CUSTOM = 'custom',
}

// Stripe Zero Decimal Currencies
export const StripeZeroDecimalCurrencies = [
  'BIF',
  'CLP',
  'DJF',
  'GNF',
  'JPY',
  'KMF',
  'KRW',
  'MGA',
  'PYG',
  'RWF',
  'UGX',
  'VND',
  'VUV',
  'XAF',
  'XOF',
  'XPF',
]

// Stripe Minimum Charge Amounts (in smallest currency unit)
export const StripeMinimumChargeAmount: Record<string, number> = {
  USD: 50, // $0.50
  EUR: 50, // €0.50
  GBP: 30, // £0.30
  AUD: 50, // A$0.50
  CAD: 50, // C$0.50
  JPY: 50, // ¥50
  INR: 50, // ₹0.50
  // Add more currencies as needed
}
